import React, { Component } from 'react'

class UserIconList extends Component {
  render () {
    return (
      <ul className='u-list'>
        {
          this.props.data.map((item, i) => {
            return (
              <li key={i}>
                <a href={item.url} target='_blank'
                  className={item.className}>
                  <em />  {item.title}
                </a>
              </li>
            )
          })
        }
      </ul>
    )
  }
}

export default UserIconList
